import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGE = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M49.788 21.74H28.261V.211a25.248 25.248 0 0 0-6.522 0v21.527H.212a25.248 25.248 0 0 0 0 6.522h21.527v21.527a25.26 25.26 0 0 0 6.522 0V28.261h21.527a25.257 25.257 0 0 0 0-6.522Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M15.217 11.957V8.696h-3.26v3.26H8.696v3.261h3.26v3.261h3.261v-3.26h3.261v-3.261h-3.26ZM38.043 11.957V8.696h-3.26v3.26H31.52v3.261h3.261v3.261h3.26v-3.26h3.262v-3.261h-3.261ZM15.217 34.782v-3.26h-3.26v3.26H8.696v3.261h3.26v3.26h3.261v-3.26h3.261v-3.26h-3.26ZM38.043 34.782v-3.26h-3.26v3.26H31.52v3.261h3.261v3.26h3.26v-3.26h3.262v-3.26h-3.261Z"
}));
FlagGE.displayName = 'FlagGE';
export default withFlagWrapper(FlagGE);
//# sourceMappingURL=index.js.map